import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { ModelForm, FormInputType, ActionButton, ActionButtonActionType, ActionButtonType } from '@shared/models';
import { InvestorDocumentsForm } from '@shared/models/investors.model';
import { Column, ColumnType } from '@shared/components/simple-table';
import { ZDialogComponent } from '../z-dialog/z-dialog.component';
import { WidgetDataListComponent } from '../widget-data-list/widget-data-list.component';
import { FileUploaderComponent } from '../file-uploader/file-uploader.component';
import { ZFormGridComponent } from '../z-form-grid/z-form-grid.component';
import { ZButtonComponent } from '../z-button/z-button.component';
import { TranslatePipe } from '@ngx-translate/core';

export interface AttachDocumentsDialogData {
  multiple?: boolean;
}

@Component({
    selector: 'app-attach-documents-dialog',
    templateUrl: './attach-documents-dialog.component.html',
    styleUrl: './attach-documents-dialog.component.scss',
    imports: [ZDialogComponent, WidgetDataListComponent, FileUploaderComponent, ZFormGridComponent, ZButtonComponent, TranslatePipe]
})
export class AttachDocumentsDialog {
  multiple: boolean;
  documentsList: FormControl<InvestorDocumentsForm[]> = new FormControl<InvestorDocumentsForm[]>([], { nonNullable: true });

  private readonly destroySubject: Subject<boolean> = new Subject();

  documentsForm: FormGroup<ModelForm<InvestorDocumentsForm>> = new FormGroup<
    ModelForm<InvestorDocumentsForm>
  >({
    nome: new FormControl('', { nonNullable: true }),
    descricao: new FormControl('', { nonNullable: true }),
    file: new FormControl([], { nonNullable: true }),
  });

  documentsColumns: Column[] = [
    {
      id: 'nome',
      name: 'Nome',
      type: ColumnType.NAME,
    },
    {
      id: 'descricao',
      name: 'Descrição',
    },
  ];

  documentsFormDialog = {
    title: 'Documentos',
    formGroup: this.documentsForm,
    inputs: [
      {
        name: 'Nome',
        type: FormInputType.TEXT,
        formControlName: 'nome',
        class: 'col-md-12',
      },
      {
        name: 'Descrição',
        type: FormInputType.TEXT,
        formControlName: 'descricao',
        class: 'col-md-12',
      },
    ],
  };

  actions: ActionButton[] = [
    {
      name: 'Baixar Documento',
      icon: 'download',
      action: ActionButtonActionType.FILE,
      color: 'green',
      type: ActionButtonType.BUTTON,
    },
    {
      name: 'Visualizar',
      icon: 'visibility',
      action: ActionButtonActionType.VIEW,
      color: 'green',
      type: ActionButtonType.BUTTON,
    },
    {
      name: 'Editar',
      icon: 'edit_note',
      action: ActionButtonActionType.EDIT,
      color: 'green',
      type: ActionButtonType.BUTTON,
    },
    {
      name: 'Deletar',
      icon: 'delete_outline',
      action: ActionButtonActionType.DELETE,
      color: 'green',
      type: ActionButtonType.BUTTON,
    },
  ];

  constructor(
    public dialogRef: MatDialogRef<AttachDocumentsDialog>,
    @Inject(MAT_DIALOG_DATA) data: AttachDocumentsDialogData | null,
  ) {
    this.multiple = data?.multiple ?? true;
  }

  ngOnInit(): void {
    this.documentsForm.controls.file.valueChanges
      .pipe(takeUntil(this.destroySubject))
      .subscribe((value: File[]) => {
        this.documentsForm.controls.nome.setValue(value ? value[0]?.name : '');
      });
  }

  send(): void {
    if (this.multiple) {
      this.dialogRef.close(this.documentsList.getRawValue());
    } else {
      this.dialogRef.close(this.documentsForm.getRawValue());
    }
  }
}
